import { ConfirmDrawer } from 'hooks/useConfirmDrawer'
import { Drawer } from 'components/Drawer'
import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './AiConfirmDrawer.module.scss'
import { Button } from 'blaze-ui/Button'

export const AiConfirmDrawer = ({ onCancel, onConfirm, onPressOutside, ...props }: ConfirmDrawer) => (
  <Drawer.Root {...props}>
    <Drawer.Portal>
      <Drawer.Content fullHeight>
        <Drawer.InnerContent isSnappedTop>
          <Drawer.Container>
            <Heading level={5}>
              Are you sure you want to leave your AI image generation work? You will lose all unsaved changes.
            </Heading>
            <div className={Styles.footer}>
              <Button fullWidth onPress={onCancel} size="lg" variant="secondary">
                Cancel
              </Button>
              <Button fullWidth onPress={onConfirm} size="lg" variant="primary">
                Confirm
              </Button>
            </div>
          </Drawer.Container>
        </Drawer.InnerContent>
      </Drawer.Content>
      <Drawer.Overlay />
    </Drawer.Portal>
  </Drawer.Root>
)
